import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CoachSettingsGeneralExternalConnectionController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-external-connection/coach-settings-general-external-connection.controller';
import { CoachSettingsGeneralExternalConnectionStore } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-external-connection/coach-settings-general-external-connection.store';
import { UserNetworkType } from 'user/model/user-network.type';

@Component({
	selector: 'spr-coach-settings-external-connection',
	templateUrl: './coach-settings-external-connection.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		CoachSettingsGeneralExternalConnectionController,
		CoachSettingsGeneralExternalConnectionStore,
	],
	host: {
		class: 'h-full',
	},
})
export class CoachSettingsExternalConnectionComponent {
	@Input()
	public set networkType(networkType: string) {
		this.controller.updateUserNetworkType(UserNetworkType[networkType]);
	}
	constructor(
		public controller: CoachSettingsGeneralExternalConnectionController
	) {}

	public onConnectClick(): void {
		this.controller.connectToUserNetwork();
	}

	public onDisconnectClick(): void {
		this.controller.disconnectFromUserNetwork();
	}

	public onReconnectClick(): void {
		this.controller.reconnectToUserNetwork();
	}

	public onSynchronizeSelectedCalendarClick(event: Event): void {
		if (!event.target) {
			return;
		}

		this.controller.synchronizeUserNetworkSelectedCalendars(event.target);
	}

	public onCalendarsIdChange(calendarsId: string[]): void {
		this.controller.updateCalendarsId(calendarsId);
	}
}
